import { Injectable } from '@angular/core';
import { Keepalive } from "@ng-idle/keepalive";

@Injectable({ providedIn: 'root' })
export class KeepAliveService {

  constructor(private keepAlive: Keepalive) {
  }

  interval(seconds?: number): number {
    return this.keepAlive.interval(seconds);
  }

  get onPing(): any {
    return this.keepAlive.onPing;
  }
}
